import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CompanyType } from '@app/models/admin.model';
import {
  CompanyTypeFormGroup,
  MergeLanguagesForm,
} from '@app/models/form.models';
import { ToastService } from '@app/services/toast.service';
import { GenericStore } from '@app/stores/generic.store';
import { MasterdataService } from '../masterdata.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CompanyTypeSaveService {
  private genericStore = inject(GenericStore);
  private translate = inject(TranslateService);

  constructor(
    private masterdata: MasterdataService,
    private toast: ToastService,
    private router: Router
  ) {}

  saveFromForms(
    form: FormGroup<CompanyTypeFormGroup>,
    original?: CompanyType | null
  ): void {
    const detailsGroup = form.get('details') as FormGroup<{
      code: FormControl<string>;
      description: FormControl<string | null>;
    }>;

    const details =
      detailsGroup.getRawValue() ??
      ({ code: '', description: null } as {
        code: string;
        description: string | null;
      });

    const localized = this.buildLocalizedFromTab(
      form.controls.localizationsTab,
      'localizedName'
    );
    const localizedType = this.buildLocalizedFromTab(
      form.controls.localizationsTab,
      'localizedTypeName'
    );

    const countriesUsed =
      form.value.countriesUsed?.countries ?? original?.countriesUsed ?? [];

    const payload: CompanyType = {
      ...(original ?? ({} as CompanyType)),
      code: String(details.code ?? '').trim(),
      description: (details.description ?? '')?.toString().trim() || null,
      isActive: original?.isActive ?? true,
      localized,
      localizedType,
      countriesUsed,
    };

    const req$ = original
      ? this.masterdata.updateCompanyType(payload)
      : this.masterdata.createCompanyType(payload);

    console.log(req$, payload);

    req$.subscribe({
      next: (res: any) => {
        if (original) {
          this.toast.success(
            this.translate.instant('admin.companyType.toasts.update')
          );
        } else {
          this.toast.success(
            this.translate.instant('admin.companyType.toasts.create')
          );
          const id = res?.data?.id ?? res?.id;
          if (id) this.router.navigate(['/admin/database/companyType', id]);
        }
      },
      error: (err: HttpErrorResponse) => {
        const msg =
          err?.error?.error?.message || err?.error?.message || err?.message;
        this.toast.error(msg);
      },
    });
  }

  private buildLocalizedFromTab(
    tabForm:
      | FormGroup<{ [language: string]: FormGroup<MergeLanguagesForm> }>
      | null
      | undefined,
    pick: 'localizedName' | 'localizedTypeName'
  ): Record<string, string> {
    const out: Record<string, string> = {};
    if (!tabForm) return out;

    const langMap = this.genericStore.languageEntityMap();

    Object.entries(tabForm.controls).forEach(([code, group]) => {
      const langKey = langMap[code]?.description;
      if (!langKey) return;

      const val = (group.controls[pick]?.value ?? '').trim();
      if (val) out[langKey] = val;
    });

    return out;
  }
}
